var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "produtividade-container" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { md: 24, lg: 12 } },
            [
              _c("app-plotly", {
                attrs: {
                  nomeDiv: "graficoProcessoPorSetor",
                  dados: _vm.graficoDados,
                  layout: _vm.layout,
                  centralizarGrafico: true
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { md: 24, lg: 12 } },
            [
              _c(
                "el-table",
                {
                  attrs: { data: _vm.dadosWithColor },
                  on: { "row-click": _vm.produtividadePorSetor }
                },
                [
                  _c("template", { slot: "empty" }, [
                    _vm._v("Nenhuma produtividade encontrada.")
                  ]),
                  _c("el-table-column", {
                    attrs: {
                      label: "Nome",
                      prop: "nome",
                      formatter: _vm.nomeFormatado
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Produtividade",
                      prop: "produtividade",
                      align: "center",
                      width: "150"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", { staticClass: "tabela-produtividade" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "content-tabela-produtividade",
                                  style: "--color: " + scope.row.color
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.produtividade))
                                  ])
                                ]
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c(
                    "el-table-column",
                    { attrs: { label: "Ação", align: "center", width: "55" } },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: "Visualizar produtividade",
                            placement: "bottom"
                          }
                        },
                        [_c("i", { staticClass: "fa fa-eye" })]
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35e2afaa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35e2afaa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/produtividade/components/GraficoProcessoPorSetor.vue
// module id = null
// module chunks = 